import { useCallback, useEffect, useState } from "react";
import MenuCM from "components/shared/menu";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import notfound from "assets/img/notfound.png";
import {
  StyledProductsMainDiv,
  StyledProductsFlex,
  StyledProductDiv,
  StyledProductImg,
  StyledProductImgDiv,
  StyledProductTitle,
  StyledProductPrice,
  StyledSlideProductDiscount,
  StyledProductBeforePrice,
  StyledColorsProduct,
} from "./Furniture.style";
import ContactCM from "components/contactus";
import { PAGINATION_LIMIT, IMG_BASE_URL } from "constants";
import LoadingCM from "components/shared/Loading";
import PaginationCM from "components/shared/Pagination";
import useHttp from "hooks/use-http";
import { GetAmazingProductsAccessoryRequest } from "api/requests";
import { Link } from "react-router-dom";
import spliter from "helper/digit-spliter";
import FooterCM from "components/shared/footer";
import SkeletonCM from "components/shared/Skeleton";
import SkeletonProductCM from "components/shared/Skeleton/product";
import {Helmet} from "react-helmet";

const skeleton = [1, 2, 3, 4, 5, 6, 7, 8];

export default function FurnitureAllProducts() {
  const { request, loading } = useHttp();
  const [page, setPage] = useState(1);
  const [productData, setProductData] = useState({
    data: [],
    count: 0,
  });

  //////////////// Get All Products  ////////////////
  const getProducts = useCallback(async () => {
    const res = await request({
      url: GetAmazingProductsAccessoryRequest,
      values: {
        skip: (page - 1) * PAGINATION_LIMIT,
        limit: PAGINATION_LIMIT,
      },
    });

    if (res) {
      if (res.count < 1) {
        return setProductData({
          count: res.count,
          data: [{ content: "هیچ محصولی یافت نشد" }],
        });
      }

      let transformedData = res.data.map((items) => ({
        id: items.id,
        title: items.title,
        price: items.price,
        image: items.image,
        design_id: items.design_id,
        discount_percent: items.discount_percent,
        before_discount_price: items.before_discount_price,
        colors: items.colors,
      }));

      setProductData({
        data: transformedData,
        count: res.count,
      });
    }
  }, [page, request]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  return (
    <>
      {/* {loading ? (
        <LoadingCM />
      ) : ( */}
      <Box>
        <Helmet>
          <title>پیشنهاد شگفت انگیز - مبلمان ویول</title>
          <meta name="product_id" content={""} />
          <meta name="product_name" content={""} />
          <meta name="product_price" content={""} />
          <meta name="product_old_price" content={""} />
          <meta name="availability" content={""} />
          <meta property="og:image" content={""} />
        </Helmet>
        <MenuCM
          Background
          pageTitle="اکسسوری"
          pageCategory="پیشنهاد شگفت انگیز"
        />
        <Grid container spacing={2} direction="row">
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <StyledProductsMainDiv>
              <StyledProductsFlex>
                <Grid container spacing={{ xs: 2, md: 3 }}>
                  {loading ? (
                    <>
                      {skeleton?.map((product, index) => (
                        <Grid item xs={12} sm={6} md={6} lg={3} key={index}>
                          <SkeletonProductCM />
                        </Grid>
                      ))}
                    </>
                  ) : (
                    <>
                      {productData.count < 1
                        ? "هیچ محصولی در مبلمان وجود ندارد"
                        : productData.data?.map((product, index) => (
                            <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                              <Link
                                to={`/product/${product.id}`}
                                key={"product" + index}
                                target={"_blank"}
                              >
                                <StyledProductDiv elevation={3}>
                                  <StyledProductImgDiv>
                                    {product.image ? (
                                      <StyledProductImg
                                        src={IMG_BASE_URL + product.image}
                                      />
                                    ) : (
                                      <StyledProductImg src={notfound} />
                                    )}
                                  </StyledProductImgDiv>
                                  <StyledColorsProduct>
                                    {product.colors?.map((color, index) => (
                                      <span
                                        key={"color" + index}
                                        style={{ background: color.color_code }}
                                      ></span>
                                    ))}
                                  </StyledColorsProduct>
                                  <StyledProductTitle>
                                    {product.title}
                                  </StyledProductTitle>
                                  {product.discount_percent !== 0 ? (
                                    <StyledProductBeforePrice>
                                      <span>
                                        {spliter(product.before_discount_price)}{" "}
                                        تومان
                                      </span>
                                    </StyledProductBeforePrice>
                                  ) : (
                                    <p
                                      style={{ height: "26px", margin: "0" }}
                                    ></p>
                                  )}
                                  <StyledProductPrice>
                                    {spliter(product.price)} تومان
                                  </StyledProductPrice>
                                  {product.discount_percent !== 0 ? (
                                    <StyledSlideProductDiscount>
                                      {" "}
                                      {product.discount_percent} %{" "}
                                    </StyledSlideProductDiscount>
                                  ) : (
                                    " "
                                  )}
                                </StyledProductDiv>
                              </Link>
                            </Grid>
                          ))}
                    </>
                  )}
                </Grid>
              </StyledProductsFlex>
            </StyledProductsMainDiv>

            {loading ? (
              <div style={{ textAlign: "center", border: "none" }}>
                <SkeletonCM
                  Width={300}
                  height={30}
                  mBottom={10}
                  mTop={10}
                  BackWrapper
                />
              </div>
            ) : (
              <>
                {productData.data.length > 0 ? (
                  <PaginationCM
                    handleChange={(e, val) => setPage(val)}
                    page={page}
                    count={productData.count}
                  />
                ) : (
                  " "
                )}
              </>
            )}
          </Grid>
        </Grid>
        <ContactCM Accessory />
        <FooterCM />
      </Box>
      {/* )} */}
    </>
  );
}
